
import { GridReportService } from "./../../_services/api/reports/grid-report.service"

export default {
    getReportLayout(gcLayOut) {
        let reportLayOuts = [
            {
                layout: "BranchCode",
                editorOptions:
                {
                    dataSource: GridReportService.dataSourceConfig("api/Branch", {
                        filter: [["Inactive", "=", "N"]],
                        sort: [{ selector: "Description", asc: true }],
                    }),
                    valueExpr: "Code",
                    displayExpr: "Description",
                    searchExpr: ["Code", "Description"],
                    searchMode: "contains",
                    searchEnabled: true,
                    showClearButton: true,
                    itemTemplate: "item-template-2",
                    primaryText: "Description",
                    secondaryText: "Code",
                }
            },
            {
                layout: "DivisionCode",
                editorOptions:
                {
                    dataSource: GridReportService.dataSourceConfig("api/Division", {
                        select: ["Code", "Description"],
                        filter: [["Inactive", "=", "N"]],
                        sort: [{ selector: "Description", asc: true }],
                    }),
                    valueExpr: "Code",
                    displayExpr: "Description",
                    searchExpr: ["Code", "Description"],
                    searchMode: "contains",
                    showClearButton: true,
                    searchEnabled: true,
                    editorType: "dxTagBox",
                    primaryText: "Description",
                    secondaryText: "Code",
                    itemTemplate: "item-template",
                }
            }
        ];

        let layout = reportLayOuts.find((x) => x.layout == gcLayOut);

        if (layout) {
            return layout.editorOptions;
        } else {
            alert("REPORT FIELD LAYOUT ERROR - Cannot find layout: " + gcLayOut);
            return "REPORT FIELD LAYOUT ERROR";
        }
    }
}